import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import DropDown from './DropDown';
import DropDownContext from './DropDownContext';
import DropDownMenuDivider from './DropDownMenuDivider';
import DropDownMenuItem from './DropDownMenuItem';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "DropDownMenu-root_6-lic"
};
const isSeparator = child => /*#__PURE__*/React.isValidElement(child) && [DropDownMenuDivider].includes(child.type);
const isFocusable = child => /*#__PURE__*/React.isValidElement(child) && [DropDownMenuItem].includes(child.type) && !child.props.disabled;
const getFocusableChildren = children => {
  const focusable = [];
  React.Children.forEach(children, child => {
    if (isFocusable(child)) {
      focusable.push(child);
    }
  });
  return focusable;
};
function DropDownMenu({
  items,
  children,
  className,
  ...extraProps
}) {
  const {
    referenceElement,
    itemsRefs,
    dispatch
  } = React.useContext(DropDownContext);
  const focusable = getFocusableChildren(children);
  const renderItem = (item, index) => /*#__PURE__*/_jsxs(React.Fragment, {
    children: [item.divider && /*#__PURE__*/_jsx("li", {
      role: "separator",
      children: /*#__PURE__*/_jsx(DropDownMenuDivider, {})
    }), /*#__PURE__*/_jsx("li", {
      role: "menuitem",
      children: /*#__PURE__*/_jsx(DropDownMenuItem, {
        to: item.to,
        href: item.href,
        type: item.type,
        icon: item.icon,
        intent: item.intent,
        disabled: item.disabled,
        onClick: item.onClick,
        ref: node => {
          itemsRefs[index] = node;
        },
        children: item.title
      })
    })]
  }, item.key || item.title);
  const renderChildren = () => React.Children.map(children, child => {
    if (isSeparator(child)) {
      return /*#__PURE__*/_jsx("li", {
        role: "separator",
        children: child
      });
    }
    if (isFocusable(child)) {
      return /*#__PURE__*/_jsx("li", {
        role: "menuitem",
        children: /*#__PURE__*/React.cloneElement(child, {
          ref: node => {
            itemsRefs[focusable.indexOf(child)] = node;
          },
          onClick: evt => {
            dispatch({
              type: 'close'
            });
            if (referenceElement) referenceElement.focus();
            if (typeof child.props.onClick === 'function') {
              child.props.onClick(evt);
            }
          }
        })
      });
    }
    return child;
  });
  const handleKeydown = evt => {
    switch (evt.key) {
      case 'Escape':
        evt.preventDefault();
        dispatch({
          type: 'close'
        });
        if (referenceElement) referenceElement.focus();
        break;
      case 'Home':
        evt.preventDefault();
        dispatch({
          type: 'selectFirstItem'
        });
        break;
      case 'End':
        evt.preventDefault();
        dispatch({
          type: 'selectLastItem'
        });
        break;
      case 'ArrowDown':
        evt.preventDefault();
        dispatch({
          type: 'selectNextItem'
        });
        break;
      case 'ArrowUp':
        evt.preventDefault();
        dispatch({
          type: 'selectPrevItem'
        });
        break;
      default:
    }
  };
  return /*#__PURE__*/_jsx(DropDown, {
    onKeyDown: handleKeydown,
    ...extraProps,
    className: clsx(styles.root, className),
    children: /*#__PURE__*/_jsx(Base, {
      tagName: "ul",
      padding: "none",
      margin: "none",
      listStyleType: "none",
      children: Array.isArray(items) ? items.map(renderItem) : renderChildren()
    })
  });
}
export default DropDownMenu;